import { createContext } from "react";

export const getLocale = async ({ translation = "en", module = "common" }) => {
  return await import(`./${translation}`)
}

export  const Il8nContext = createContext({})